import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ShowIfTruncatedDirective } from '../../../utils/directives/show-if-truncated.directive';

@Component({
  selector: 'aside-header',
  imports: [MatIcon, MatIconModule, MatButtonModule, NgTemplateOutlet, MatTooltip, ShowIfTruncatedDirective],
  templateUrl: './aside-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './aside-header.component.scss',
})
export class AsideHeaderComponent implements OnInit {
  /* Pass icon + title or ngTemplate */
  @Input() icon?: MatIcon['fontIcon'];
  @Input() title?: string;
  @Input() template?: TemplateRef<any>;
  @Input() backIcon: MatIcon['fontIcon'] = 'arrow_back';
  @Input() isBackDisabled = false;

  @Output() onBack = new EventEmitter();

  public isBackEventListened: boolean = false;
  public static ASIDE_HEADER_HEIGHT: number = 0;

  constructor(private _ref: ElementRef) {}

  ngOnInit(): void {
    this.isBackEventListened = this.onBack.observers.length > 0;
    AsideHeaderComponent.ASIDE_HEADER_HEIGHT = this._ref.nativeElement.clientHeight;
  }

  public back() {
    this.onBack.emit();
  }
}
